import { useQuery } from '@tanstack/react-query';
import { profileApi } from '~/lib/request';
import { Theme } from './types';

function useThemes() {
  const result = useQuery({
    queryKey: ['themes'],
    queryFn: () => profileApi.get('api/common/themes').json<Theme[]>(),
    throwOnError: true,
  });

  return result.data;
}

export default useThemes;
